class PredictiveSearchModal {
  constructor() {
    this.modal = document.getElementById('PredictiveSearchModal');
    if (!this.modal) return;
    this.input = document.getElementById('PredictiveSearchInput');
    this.closeBtn = document.getElementById('PredictiveSearchClose');
    this.emptyState = document.getElementById('PredictiveSearchEmptyState');
    this.results = document.getElementById('PredictiveSearchResults');
    this.skeleton = document.getElementById('PredictiveSearchSkeleton');
    this.suggestions = document.getElementById('PredictiveSearchSuggestions');
    this.recentSection = document.getElementById('PredictiveSearchRecentSection');
    this.recentGrid = document.getElementById('PredictiveSearchRecentGrid');
    this.clearRecentBtn = document.getElementById('PredictiveSearchClearRecent');
    
    this.debounceTimer = null;
    this.storageKey = 'recently_viewed_products';
    
    this.init();
  }

  init() {
    this.closeBtn.addEventListener('click', () => this.close());
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.close();
    });
    this.input.addEventListener('input', (e) => this.onSearchInput(e));
    this.input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        const query = this.input.value.trim();
        if (query) {
          this.close();
          window.location.href = `/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide&q=${encodeURIComponent(query)}`;
        }
      }
    });
    
    // Bind search icon click triggers in the header
    const bindSearchTriggers = () => {
      document.querySelectorAll('.header__icon--search, [data-predictive-search-open], #search-toggle').forEach(button => {
        if (button.dataset.modalBound) return;
        button.dataset.modalBound = 'true';
        
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          // Close details parent if present to prevent native details open
          const details = button.closest('details');
          if (details) details.removeAttribute('open');
          this.open();
        });
      });
    };
    
    bindSearchTriggers();
    // Re-bind on mutation/intervals in case header is dynamically re-rendered
    document.addEventListener('shopify:section:load', bindSearchTriggers);
    setInterval(bindSearchTriggers, 1000);
    
    // Clear recent products
    if (this.clearRecentBtn) {
      this.clearRecentBtn.addEventListener('click', () => this.clearRecentlyViewed());
    }

    // Capture clicks on product cards to store in Recently Viewed
    document.addEventListener('click', (e) => {
      // Handle the 'Search for' term suggestion button click
      const termBtn = e.target.closest('.predictive-search__item--term');
      if (termBtn) {
        e.preventDefault();
        e.stopPropagation();
        const query = this.input.value.trim();
        if (query) {
          this.close();
          window.location.href = `/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide&q=${encodeURIComponent(query)}`;
        }
        return;
      }

      const card = e.target.closest('.predictive-search-card, .predictive-search__item, .product-card-wrapper');
      if (card) {
        // Collect card elements safely
        const titleEl = card.querySelector('.predictive-search-card__title, .predictive-search__item-heading, .card__heading a, .full-unstyled-link');
        const vendorEl = card.querySelector('.predictive-search-card__vendor, .predictive-search__item-vendor, .text_vendor');
        const priceEl = card.querySelector('.predictive-search-card__price, .price');
        const imgEls = card.querySelectorAll('.predictive-search-card__media img, .predictive-search__image, .media img, .card__media img');
        const mainImage = card.dataset.image || card.getAttribute('data-image') || (imgEls[0] ? imgEls[0].src : '');
        const secondaryImage = card.dataset.image2 || card.getAttribute('data-image2') || (imgEls[1] ? imgEls[1].src : '');
        
        let priceText = '';
        if (priceEl) {
          const salePrice = priceEl.querySelector('.price-item--sale');
          const regularPrice = priceEl.querySelector('.price-item--regular');
          if (priceEl.classList.contains('price--on-sale') && salePrice) {
            priceText = salePrice.textContent.trim();
          } else if (regularPrice) {
            priceText = regularPrice.textContent.trim();
          } else {
            priceText = priceEl.textContent.trim();
          }
          priceText = priceText.replace(/\s+/g, ' ');
        }

        let id = card.dataset.id || card.getAttribute('data-id');
        if (!id) {
          const quickAddOpen = card.querySelector('modal-opener');
          if (quickAddOpen && quickAddOpen.getAttribute('data-modal')) {
            id = quickAddOpen.getAttribute('data-modal').replace('#QuickAdd-', '');
          }
        }
        if (!id) {
          const form = card.querySelector('product-form form');
          if (form) {
            const idInput = form.querySelector('input[name="id"]');
            if (idInput) id = idInput.value;
          }
        }
        if (!id) {
          id = Math.random().toString(36).substr(2, 9);
        }

        const productData = {
          id: id,
          title: card.dataset.title || card.getAttribute('data-title') || (titleEl ? titleEl.textContent.trim() : ''),
          vendor: card.dataset.vendor || card.getAttribute('data-vendor') || (vendorEl ? vendorEl.textContent.trim() : ''),
          price: card.dataset.price || card.getAttribute('data-price') || priceText,
          image: mainImage,
          image2: secondaryImage,
          url: card.getAttribute('href') || (card.querySelector('a') ? card.querySelector('a').getAttribute('href') : '')
        };
        if (productData.title && productData.url) {
          this.addRecentlyViewed(productData);
        }
      }
    });

    // Keyboard handlers
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('is-active')) {
        this.close();
      }
    });

    this.loadRecentlyViewed();
  }

  open() {
    this.modal.removeAttribute('hidden');
    // Force reflow for CSS transition
    this.modal.offsetHeight;
    this.modal.classList.add('is-active');
    document.body.classList.add('overflow-hidden');
    setTimeout(() => this.input.focus(), 50);
  }

  close() {
    this.modal.classList.remove('is-active');
    document.body.classList.remove('overflow-hidden');
    const onTransitionEnd = (e) => {
      if (e.propertyName === 'opacity' && !this.modal.classList.contains('is-active')) {
        this.modal.setAttribute('hidden', '');
        this.modal.removeEventListener('transitionend', onTransitionEnd);
      }
    };
    this.modal.addEventListener('transitionend', onTransitionEnd);
  }

  onSearchInput(e) {
    const query = e.target.value.trim();
    clearTimeout(this.debounceTimer);

    if (query.length < 2) {
      this.results.setAttribute('hidden', '');
      this.emptyState.removeAttribute('hidden');
      this.suggestions.innerHTML = '';
      return;
    }

    this.emptyState.setAttribute('hidden', '');
    this.results.removeAttribute('hidden');
    if (this.skeleton) this.skeleton.removeAttribute('hidden');
    this.suggestions.innerHTML = '';

    this.debounceTimer = setTimeout(() => {
      this.fetchSuggestions(query);
    }, 250);
  }

  fetchSuggestions(query) {
    const endpoint = `/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product&resources[options][unavailable_products]=hide&section_id=predictive-search`;
    
    fetch(endpoint)
      .then(res => {
        if (!res.ok) throw new Error('Search failed');
        return res.text();
      })
      .then(html => {
        if (this.skeleton) this.skeleton.setAttribute('hidden', '');
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const resultsEl = doc.querySelector('#predictive-search-results');
        
        if (resultsEl && resultsEl.querySelector('.predictive-search__list-item')) {
          this.suggestions.innerHTML = resultsEl.outerHTML;
        } else {
          this.suggestions.innerHTML = `
            <div class="predictive-search-no-results">
              <h3>No products found</h3>
              <p>Try another keyword.</p>
            </div>
          `;
        }
      })
      .catch(err => {
        console.error(err);
        if (this.skeleton) this.skeleton.setAttribute('hidden', '');
        this.suggestions.innerHTML = `
          <div class="predictive-search-no-results">
            <h3>Unable to load search results.</h3>
            <p>Please try again.</p>
          </div>
        `;
      });
  }

  addRecentlyViewed(product) {
    let items = this.getRecentlyViewed();
    // Filter duplicates
    items = items.filter(item => item.id !== product.id && item.title !== product.title);
    // Add to top
    items.unshift(product);
    // Limit to 10
    if (items.length > 10) items.pop();
    
    localStorage.setItem(this.storageKey, JSON.stringify(items));
    this.loadRecentlyViewed();
  }

  getRecentlyViewed() {
    try {
      const data = localStorage.getItem(this.storageKey);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  loadRecentlyViewed() {
    const items = this.getRecentlyViewed();
    if (!items.length) {
      this.recentSection.setAttribute('hidden', '');
      return;
    }

    this.recentGrid.innerHTML = items.map(item => `
      <div class="card-wrapper product-card-wrapper" data-id="${item.id}" data-title="${item.title}" data-vendor="${item.vendor || ''}" data-price="${item.price}" data-image="${item.image}" data-image2="${item.image2 || ''}">
        <a href="${item.url}" class="product-card__image-link">
          <div class="card card--card card--media">
            <div class="card__inner ratio" style="--ratio-percent: 100%;">
              <div class="card__media">
                <div class="media media--transparent media--hover-effect">
                  <img src="${item.image}" alt="${item.title}" loading="lazy" width="120" height="120">
                  ${item.image2 ? `<img src="${item.image2}" alt="" class="motion-reduce" loading="lazy" width="120" height="120">` : ''}
                </div>
              </div>
            </div>
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading h5">
                  ${item.vendor ? `<span class="text_vendor">${item.vendor}</span>` : ''}
                  <span class="full-unstyled-link">${item.title}</span>
                </h3>
                <div class="card-information">
                  <div class="price">${item.price || ''}</div>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    `).join('');
    
    this.recentSection.removeAttribute('hidden');
  }

  clearRecentlyViewed() {
    localStorage.removeItem(this.storageKey);
    this.loadRecentlyViewed();
  }
}

// Instantiate on load
document.addEventListener('DOMContentLoaded', () => {
  window.predictiveSearchModal = new PredictiveSearchModal();
});
